import request from '@/router/axios'

export function fetchList(query) {
	return request({
		url: '/dist/distAccount/page',
		method: 'get',
		params: query,
	})
}

export function addObj(obj) {
	return request({
		url: '/dist/distAccount',
		method: 'post',
		data: obj,
	})
}

export function getObj(id) {
	return request({
		url: '/dist/distAccount/' + id,
		method: 'get',
	})
}

export function delObj(id) {
	return request({
		url: '/dist/distAccount/' + id,
		method: 'delete',
	})
}

export function putObj(obj) {
	return request({
		url: '/dist/distAccount',
		method: 'put',
		data: obj,
	})
}
